module.exports = __webpack_public_path__ + "media/applications/assets/images/materials/classic-woman-tee/6-2-ec3ea0dc48d98a99f5cfb3336b47f7e7.jpg";